// extracted by mini-css-extract-plugin
export default {"btn":"MintWeb3IdBtn_btn__7kxo6","icon":"MintWeb3IdBtn_icon__6EGtk"};